import { render, staticRenderFns } from "./newdetail.vue?vue&type=template&id=7c79e6fc&scoped=true&"
import script from "./newdetail.vue?vue&type=script&lang=js&"
export * from "./newdetail.vue?vue&type=script&lang=js&"
import style0 from "./newdetail.vue?vue&type=style&index=0&id=7c79e6fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c79e6fc",
  null
  
)

export default component.exports